"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaEligibilityFactory = exports.waiverPersonaEligibilityCredentialFactory = exports.membershipPersonaEligibilityCredentialFactory = exports.membershipServicePersonaEligibilityCredentialFactory = exports.apsTrainingPersonaEligibilityCredentialFactory = exports.apsServicePersonaEligibilityCredentialFactory = exports.personaEligibilityCredentialFactory = exports.credentialSetFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
const util_1 = require("../../util");
exports.credentialSetFactory = Factory.Sync.makeFactory({
    organization_id: Mocks.orgClub.id,
    effective_at: Mocks.dates.date2000,
    expires_at: Mocks.dates.date2100,
    eligibility_status: 'eligible',
    status: 'complete',
    organization_ids: [Mocks.orgClub.id, Mocks.orgNgb.id],
    completed_at: Mocks.dates.date2000,
    trigger_credential_type: util_1.resources.membership,
    trigger_credential_value: Mocks.membership.id,
    trigger_credential_system: util_1.services.MembershipService,
});
exports.personaEligibilityCredentialFactory = Factory.Sync.makeFactory({
    credential_type: null,
    credential_value: null,
    credential_system: null,
    rule_type: null,
    rule_value: null,
    rule_system: null,
    status: 'complete',
    effective_at: Mocks.dates.date2000,
    expires_at: null,
    trigger: true,
    eligibility_status: 'complete',
});
exports.apsServicePersonaEligibilityCredentialFactory = exports.personaEligibilityCredentialFactory.extend({
    credential_system: util_1.services.SeApsService,
    rule_system: util_1.services.SeApsService,
});
exports.apsTrainingPersonaEligibilityCredentialFactory = exports.apsServicePersonaEligibilityCredentialFactory.extend({
    credential_type: util_1.resources.aps,
    credential_value: Factory.each(() => uuid_1.v4()),
    rule_type: util_1.resources.aps,
    rule_value: util_1.resources.aps,
});
exports.membershipServicePersonaEligibilityCredentialFactory = exports.personaEligibilityCredentialFactory.extend({
    credential_system: util_1.services.MembershipService,
    rule_system: util_1.services.MembershipService,
});
exports.membershipPersonaEligibilityCredentialFactory = exports.membershipServicePersonaEligibilityCredentialFactory.extend({
    credential_type: util_1.resources.membership,
    credential_value: Factory.each(() => uuid_1.v4()),
    rule_type: util_1.resources.membership_definition,
    rule_value: Mocks.membership.membership_definition_id,
});
exports.waiverPersonaEligibilityCredentialFactory = exports.membershipServicePersonaEligibilityCredentialFactory.extend({
    credential_type: util_1.resources.waiver_acceptance,
    credential_value: Mocks.waiverAcceptance.id,
    rule_type: util_1.resources.waiver,
    rule_value: Mocks.waiverAcceptance.waiver_id,
});
exports.personaEligibilityFactory = Factory.Sync.makeFactory({
    date_of_birth: Mocks.dates.date2000,
    effective_at: Mocks.dates.date2000,
    eligibility_rule_set_id: Factory.each(() => uuid_1.v4()),
    eligibility_rule_set_name: 'Test Rule Set',
    eligibility_rule_set_organization_id: Mocks.orgNgb.id,
    incomplete_credential_count: 0,
    email: Mocks.persona.email,
    expires_at: Mocks.dates.date2100,
    first_name: Mocks.persona.first_name,
    gender: 'male',
    last_name: Mocks.persona.last_name,
    middle_name: null,
    name: Mocks.persona.full_name,
    membership_number: 'TEST-1234',
    organization_ids: [Mocks.orgClub.id, Mocks.orgNgb.id],
    owner_user_id: null,
    persona_id: Mocks.persona.id,
    persona_type_id: Mocks.persona.persona_type_id,
    played_outside_us: null,
    profile_image: Mocks.persona.profile_image,
    suffix: null,
    affiliation_path: Mocks.affiliationPath,
    eligibility_credentials: [
        exports.membershipPersonaEligibilityCredentialFactory.build()
    ],
    credential_sets: [
        exports.credentialSetFactory.build()
    ],
    action_required_to_become_eligible: false,
    unfinished_user_task_count: 0,
    unfinished_admin_task_count: 0,
    status: 'complete',
    completed_at: Mocks.dates.date2000,
    created_at: Mocks.dates.date2000,
    legal: Mocks.legal,
    started_at: Mocks.dates.date2000,
    updated_at: Mocks.dates.date2000,
});
